module.exports = __webpack_public_path__ + "static/media/blood-orange-1.6febb3f9.png";